(() => {
  if (customElements.get('ondelie-pdp-filtration')) return;

  class OndeliePdpFiltration extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.tabs = Array.from(this.querySelectorAll('[data-opf-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-opf-panel]'));

      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-opf-tab]');
        if (tab && this.contains(tab)) this.selectTab(tab);
      });

      this.addEventListener('keydown', (event) => this.handleKeydown(event));
      this.mountReveal();
    }

    selectTab(selectedTab, moveFocus = false) {
      const panelId = selectedTab.getAttribute('aria-controls');

      this.tabs.forEach((tab) => {
        const isSelected = tab === selectedTab;
        tab.classList.toggle('is-active', isSelected);
        tab.setAttribute('aria-selected', String(isSelected));
        tab.tabIndex = isSelected ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        const isSelected = panel.id === panelId;
        panel.hidden = !isSelected;
        panel.classList.toggle('is-active', isSelected);
      });

      if (moveFocus) selectedTab.focus();
    }

    handleKeydown(event) {
      const currentTab = event.target.closest('[data-opf-tab]');
      if (!currentTab || !this.contains(currentTab)) return;

      const currentIndex = this.tabs.indexOf(currentTab);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
      else if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      else if (event.key === 'Home') nextIndex = 0;
      else if (event.key === 'End') nextIndex = this.tabs.length - 1;
      else return;

      event.preventDefault();
      this.selectTab(this.tabs[nextIndex], true);
    }

    mountReveal() {
      this.classList.add('is-mounted');

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        this.classList.add('is-visible');
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        if (!entries[0]?.isIntersecting) return;
        this.classList.add('is-visible');
        observer.disconnect();
      }, { threshold: 0.12 });

      observer.observe(this);
    }
  }

  customElements.define('ondelie-pdp-filtration', OndeliePdpFiltration);
})();
